import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/auth-store';

function pickGreetingKey(hour: number): string {
  if (hour < 5) return 'home.greet_late';
  if (hour < 12) return 'home.greet_morning';
  if (hour < 18) return 'home.greet_afternoon';
  return 'home.greet_evening';
}

export function Greeting() {
  const { t, i18n } = useTranslation();
  const user = useAuthStore((s) => s.user);

  const { greeting, dateLabel } = useMemo(() => {
    const now = new Date();
    return {
      greeting: t(pickGreetingKey(now.getHours()), {
        name: user?.displayName ?? user?.username ?? '',
      }),
      dateLabel: now.toLocaleDateString(i18n.language, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }),
    };
  }, [t, i18n.language, user]);

  return (
    <div className="home-greeting">
      <div className="home-greeting-hi">{greeting}</div>
      <div className="home-greeting-date">{dateLabel}</div>
    </div>
  );
}
